import React from "react"
import styled from "styled-components"

const Button = styled.button`
	padding: 10px;
	border: none;
	border-radius: 5px;
	cursor: ${(props) => props.disabled ? 'not-allowed' : 'pointer'};
	background: ${(props) => props.disabled ? '#b0b0b0' : 'linear-gradient(180deg, #ff9250 0%, #f37021 100%)'};
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	color: #ffffff;
`;

const PrimaryButton = ({children,...props}) => {
    return (
    <Button type="button" {...props}>
        {children}
    </Button>
    )
}

export default PrimaryButton;

